import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import styled from 'styled-components'

import { MediaItem } from 'pages/media/components/MediaItem'
import { getSinglePost } from 'services/endpoints/post'
import colors from 'styles/colors'

interface LinkPostProps {
  message: string
}

const ErrorMessage = () => (
  <LinkPostContainer>
    This post does not exist or you do not have access.
  </LinkPostContainer>
)

export const LinkPost = ({ message }: LinkPostProps) => {
  const { t } = useTranslation()

  // extract numeric id from /post/:id
  const match = message.match(/\/post\/([^/?#]+)/)
  const postId = match?.[1]

  if (!postId) {
    return <ErrorMessage />
  }

  const { data, isLoading, error } = useQuery(
    ['getSinglePost', postId],
    async () => await getSinglePost(postId),
    {
      refetchOnWindowFocus: false,
      enabled: !!postId
    }
  )
  if (error) return <ErrorMessage />
  if (isLoading) return <LinkPostContainer>{t('loading')}...</LinkPostContainer>

  const postData = data?.data
  if (!postData) return <ErrorMessage />

  return (
    <LinkPostContainer>
      <MediaItem
        wrapperWidth="100%"
        postData={postData}
        hideOptions={true}
        // FIX: provide a function, not the string id
        setIsActive={() => {}}
      />
    </LinkPostContainer>
  )
}

const LinkPostContainer = styled.div`
  border-radius: 2rem;
  padding: 1rem;
  background: ${colors.white90deg};
  margin: 1rem 0rem;
  font-size: 1.4rem;
`
